<template>
  <div v-if="profile" class="gmf-customer-card">
    <div class="gmf-customer-card-container">
      <MyPagesMenu 
        :customerId="merchantCustomerId"
        :selectedItem="selectedItem"
        @item-selected="handleItemSelected"
        @openSettings="openSettings"
        :profile="profile"
        :detached="!isDesktop"
        side="right"
        :closed="!expanded"
        :hideAvatar="isDesktop || !use3DAvatar"
        :pauseAvatar="!modalState.isTopModal"
        @touchstart.stop @click.stop.prevent="expanded = false" @mousedown.stop @touchmove.stop
      />
      <div class="gmf-customer-card-content" :style="scrollHeight" ref="container">
        <Transition name="gmf-fade-overlay">
          <div class="gmf-modal-overlay" v-if="expanded && !isDesktop" @touchstart.stop @click.stop.prevent="expanded = false" @mousedown.stop @touchmove.stop.prevent></div>
        </Transition>
        <span class="gmf-subheader" v-if="!selectedItem?.hideHeader">{{ selectedItem?.name }}</span>

        <div class="gmf-text-small gmf-mb-5" v-if="ingress">{{ ingress }}</div>

        <ProfilePage v-if="selectedItem?.value === 'profile'" :profile="profile" @scrollTop="scrollTop"/>
        <div v-else-if="!isMyProfile && !profile.publicProfile" class="gmf-popup-profile-content-private">
          {{ state.t('profile_is_private') }}
        </div>
        <template v-else>
          <NotificationList v-if="selectedItem?.value === 'notifications'" />
          <QuestList v-else-if="selectedItem?.value === 'quests'" />
          <AchievementsList v-else-if="selectedItem?.value === 'achievements'" modeOverride="list"
            :hideDescription="true" :customerId="profile.id" />
          <CommentList v-else-if="selectedItem?.value === 'my_content'" :hideDescription="true" :showTargetImages="false"
            :disableProfilePopup="true" :customerId="profile.id" />
          <CustomerAttributeEditor v-else-if="selectedItem?.value === 'customer_settings'" />
          <ConversationList v-else-if="selectedItem?.value === 'direct_messages'" />
          <OrderedProductList v-else-if="selectedItem?.value === 'ordered_products'" />
          <Inventory v-else-if="selectedItem?.value === 'inventory'" :customerId="profile.id" />
        </template>
        <div class="gmf-customer-card-footer" ref="footer">
          <div @mousedown.stop="expanded = !expanded" @touchstart.stop class="gmf-btn gmf-btn-primary gmf-customer-card-footer-board">
            <Icon icon="hamburger" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.gmf-modal-body.gmf-customer-card-modal {
  padding: 0;
  height: 100%;
  background: none;
  overflow: hidden;
}

.gmf-customer-card-modal .gmf-fullbody-avatar {
  height: 250px;
  /*width: 180px;*/
  width: 100%;
  max-width: unset;
  margin-bottom: 30px;
}

.gmf-customer-card-navigation .gmf-fullbody-avatar {
  height: 150px;
  flex-shrink: 0;
}

@media (min-width: 1000px) {
  .gmf-modal-body.gmf-customer-card-modal {
    max-height: 800px;
  }
  .gmf-customer-card-footer {
    display: none !important;
  }
}

.gmf-customer-card-content-margin {
  position: relative;
  z-index: 1;
}
@media (max-width: 1000px) {
  .gmf-modal-body.gmf-customer-card-modal {
    overflow: hidden;
  }
  /*.gmf-customer-card-navigation .gmf-fullbody-avatar {
    height: 220px;
    width: 100%;
    max-width: unset;
    flex-shrink: 0;
  }*/
}

.gmf-customer-card-skin {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
}

.gmf-customer-card {
  max-width: 100%;
  
  display: flex;
  flex-direction: column;
  
  height: 100%;
}

.gmf-customer-card .gmf-fullbody-avatar-content {
  width: 110%;
  height: 110%;
  max-width: 110%;
  max-height: 110%;
  transform: translateX(-50%);
  left: 50%;
}

.gmf-customer-card.gmf-dark {
  background: black;
}

.gmf-customer-card .gmf-customer-card-skin {
  height: 520px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
}

.gmf-customer-card-header {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: var(--gmf-p-4);
  z-index: 1;
  gap: 10px;
  margin-top: 10px;
  width: 250px;
}

/* gmf-dark skin */
.gmf-customer-card-header .gmf-customer-name {
  color: var(--gmf-col-white);
}
.gmf-customer-card-header .gmf-customer-card-stats {
  --gmf-icon-color: var(--gmf-col-white);
  color: var(--gmf-col-white);
}
.gmf-customer-card-header .gmf-level-row-level {
  color: var(--gmf-col-white);
}

.gmf-customer-card-info {
  display: flex;
  gap: var(--gmf-p-2);
  flex-direction: column;
}

.gmf-customer-card-info>.gmf-subheader {
  margin-bottom: 0;
}

.gmf-customer-card-container {
  display: flex;
  flex-grow: 1;
  height: 100%;
}

.gmf-customer-card-stats {
  display: flex;
  align-items: center;
  gap: var(--gmf-p-3);
}

.gmf-customer-card-small-avatar {
  display: inline;
  height: 0px;
  width: 0px;
  opacity: 0;
  transition-duration: 200ms;
  transition-timing-function: ease-out;
  transition-property: width, height, opacity;
  will-change: width, height, opacity;
}

.gmf-customer-card-small-avatar.gmf-active {
  width: 64px;
  height: 64px;
  margin-right: var(--gmf-p-3);
  opacity: 1;
}

.gmf-customer-card-scrollable {
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  margin-top: 0px;
  overscroll-behavior-y: none;
}

.gmf-customer-card-content-actions {
  position: absolute;
  width: 100%;
  bottom: 100%;
  right: 0;
  z-index: 1;
  display: flex;
  gap: var(--gmf-p-3);
  flex-direction: row-reverse;
  margin-bottom: var(--gmf-p-4);
  justify-content: space-between;
  padding-inline: var(--gmf-p-4);
}

.gmf-customer-card-change-avatar {
  cursor: pointer;
  width: 30px;
  height: 30px;
}


.gmf-customer-card-avatar {
  position: absolute;
  inset: 0;
  transition: opacity 150ms ease-in-out;
  will-change: opacity;
}

.gmf-customer-card-avatar.gmf-active {
  opacity: 1;
}

.gmf-customer-card-avatar .gmf-avatar {
  background: none;
  height: 448px;
  position: absolute;
  top: 0;

  transform: translateX(-50%);
  left: 50%;
}

.gmf-customer-card-avatar .gmf-avatar-content {
  -webkit-user-drag: none;
  user-select: none;
  border-radius: 0;
  width: auto;
  margin: auto;
}

.gmf-customer-card-content {
  background: var(--gmf-col-lightgray);
  padding: 0 var(--gmf-p-4);
  position: relative;
  z-index: 1;
  padding-bottom: var(--gmf-p-4);
  overflow-y: scroll;
  width: 500px;

  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.gmf-customer-card-content::-webkit-scrollbar,
.gmf-customer-card-container::-webkit-scrollbar,
.gmf-customer-card-scrollable::-webkit-scrollbar {
  display: none;
}

.gmf-customer-card-content>.gmf-subheader {
  margin-bottom: 0;
  background: inherit;
  display: block;
  
  position: sticky;
  z-index: 2;
  top: 0;
  
  padding: var(--gmf-p-4);
  margin-left: calc(0px - var(--gmf-p-4));
  margin-right: calc(0px - var(--gmf-p-4));
  border-top-left-radius: var(--gmf-modal-rounding);
  border-top-right-radius: var(--gmf-modal-rounding);
}

.gmf-customer-card-content .gmf-notification-list {
  gap: var(--gmf-p-3);
}

.gmf-customer-card-content .gmf-cheevo-list .gmf-cheevo {
  background: var(--gmf-card-col-ongray);
}

.gmf-customer-card-content .gmf-multi-select {
  background: none;
}

.gmf-customer-card-content .gmf-comment-body {
  background: var(--gmf-card-col-ongray);
}

.gmf-customer-card-content .gmf-quest {
  background: var(--gmf-quest-bg-ongray);
}

.gmf-customer-card-content .gmf-quest-list {
  padding-bottom: var(--gmf-p-4);
}

.gmf-customer-card-content .gmf-customer-attribute-editor-footer {
  bottom: var(--gmf-p-4);
}

.gmf-customer-card-content .gmf-customer-attribute-editor-footer .gmf-btn {
  margin: auto;
}

.gmf-customer-card-content .gmf-cheevo-list .gmf-achievement-image {
  width: 64px;
  height: 64px;
}

.gmf-customer-card-content .gmf-dropdown-value  {
  display: flex;
}

.gmf-customer-card-content .gmf-dropdown-contents, .gmf-customer-card-content .gmf-dropdown {
  width: 100%;
}

.gmf-customer-card-tokens {
  display: flex;
  align-items: center;
  gap: var(--gmf-p-2);
}

.gmf-customer-card-action-bubble {
  background-color: var(--gmf-col-lightgray);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--gmf-rounding);
  padding: var(--gmf-p-2) var(--gmf-p-3);
  cursor: pointer;
  gap: var(--gmf-p-3);
}

.gmf-customer-card-footer .gmf-customer-card-footer-board {
  position: absolute;
  bottom: var(--gmf-p-4);
  padding: 25px !important;
  line-height: 0;
} 

.gmf-customer-card-footer {
  position: fixed;
  display: flex;
  z-index: 2;
  width: 100%;
  bottom: var(--gmf-p-3);
  padding-inline: var(--gmf-p-3);
}

.gmf-customer-card-footer>.gmf-btn {
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2) !important;
}

.gmf-customer-card-footer .gmf-btn {
  border-radius: 32px;
}
.gmf-customer-card-footer-board .gmf-icon {
    position: absolute;
    transform: translate(-50%, -50%);
    --gmf-icon-color: var(--gmf-col-white);
}
</style>

<script>
import state from '@/state';

import Icon from '@/components/Icon';

//import CustomerName from '@/components/CustomerName';
//import CustomerLevelRow from '@/components/CustomerLevelRow';
import AchievementsList from '@/widgets/AchievementList';

import { defineAsyncComponent } from 'vue';

const CommentList = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/widgets/CommentList');
});
const ProfilePage = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/ProfilePage');
});
const NotificationList = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/widgets/Notifications/List');
});
const CustomerAttributeEditor = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/CustomerAttributeEditor');
});
const QuestList = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/QuestList');
});

const ConversationList = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/DirectMessages/ConversationList');
});

const OrderedProductList = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/OrderedProductList');
});

const Inventory = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/Inventory');
});

import openSocialModal from '@/widgets/SocialFeed/openSocialModal';
import openInModal from '@/legacy/avatar-configurator/openInModal';
import openTokenShop from '@/components/TokenShop/openTokenShop';
import getCustomerAttributeTypes from '@/utils/getCustomerAttributeTypes';
import { default as openAvatarConfigurator3d } from '@/components/AvatarConfigurator/openAvatarConfigurator';
import eventbus from '@/utils/eventbus';

import MyPagesMenu from '@/components/MyPagesMenu';

import callApi from '@/utils/callApi';

const t = state.t.prefix('profile_tabs');

const SCROLL_MARGIN = 448;

import isSafari from '@/utils/isSafari';

export default {
  inject: ['modalState'],
  props: {
    merchantCustomerId: {
      type: String,
      required: true,
    },
    defaultTab: {
      type: String,
      default: 'profile',
    },
  },
  name: 'CustomerCard',
  components: {
    NotificationList,
    QuestList,
    AchievementsList,
    CommentList,
    CustomerAttributeEditor,
    ConversationList,
    OrderedProductList,
    Inventory,
    ProfilePage,
    MyPagesMenu,
    Icon,
  },
  data() {
    return {
      state,
      profile: null,
      expanded: true,
      iconOpacity: 1,
      dragState: { y: 0, top: 0 },
      selectedItem: null,
      customerAttributeTypes: null,
      tokenBalances: null,
      windowWidth: window.innerWidth,
      links: [],
      realtimeLoaded: false,
      isSafari,
      fullbodyLoading: false,
    };
  },
  async mounted() {
    this.loadProfile();
    if (this.isMyProfile) {
      if (this.showTokenShop) {
        this.getBalance()
      }
      this.loadProfileLinks();
    } else {
      this.expanded = false;
    }

    this.customerAttributeTypes = await getCustomerAttributeTypes();
    window.addEventListener('resize', this.updateWindowWidth);
    eventbus.on('setCustomerCardTab', this.openTab);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth);
    eventbus.off('setCustomerCardTab', this.openTab);
  },
  methods: {
    t,
    openTokenShop,
    clickItem(item, evt) {
      if (this.expanded || this.isDesktop) {
        if (item.action) {
          item.action(evt);
        } else {
          this.selectedItem = item;
        }
        this.expanded = false;
      } else {
        this.expanded = true;
      }
    },
    async getBalance() {
      const res = await callApi('GET', '/v1/client/my-balance');
  
      if (res.status === 401) {
        return null;
      }
      
      const tokenBalances = await res.json();
      this.tokenBalances = tokenBalances;
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    async loadProfileLinks () {
      const res = await callApi('GET', '/v1/profile-links');
      const { links } = await res.json();
      
      this.links = links;
    },
    async loadProfile () {
      const res = await callApi('GET', '/v1/client/profile/' + this.merchantCustomerId);
      const profile = await res.json();
      this.profile = profile;
      
      this.$nextTick(() => {
        if (this.defaultTab) {
          this.selectedItem = this.menuItems.find(item => item.value === this.defaultTab);
        }
        if (!this.selectedItem) {
          this.selectedItem = this.menuItems[0];
        }
      });
    },
    scrollTop() {
      if (this.$refs.container) {
        this.$refs.container.scrollTop = 0;
      }
    },
    openTab(tab) {
      eventbus.emit('customerCardExists', this.profile?.id);
      if (tab) {
        this.selectedItem = this.menuItems.find(item => item.value === tab);
      }
    },
    handleItemSelected(item) {
      this.selectedItem = item;
      this.expanded = false;
      this.scrollTop();
    },
    openSettings () {
      if (! this.isMyProfile) return;

      if (this.selectedItem?.value === 'customer_settings') {
        return;
      }
      this.selectedItem = this.menuItems.find(item => item.value === 'customer_settings');
      this.expanded = false;
    },
    openAvatarConfigurator () {
      if (this.use3DAvatar) {
        openAvatarConfigurator3d();
      } else {
        openInModal();
      }
    },
    updateFullbodyLoading (value) {
      this.fullbodyLoading = value;
    }
  },
  computed: {
    ingress () {
      if (! this.selectedItem) {
        return null;
      }
      if (! this.isMyProfile) {
        const v = t('ingress_others.' + this.selectedItem.value);
        if (v) {
          return v;
        }
      }
      return t('ingress.' + this.selectedItem.value);
    },
    canEditAvatar () {
      if (! this.isMyProfile) {
        return false;
      }
      const avatarType = state.merchantConfig.avatars.enabled;
      if (avatarType === '3D' || avatarType === 'enabled') {
        return true;
      }
      return false;
    },
    useRealtimeAvatar () {
      return this.use3DAvatar && state.merchantConfig.avatars?.realtime?.enabled;
    },
    myPagesUrl() {
      return state.merchantConfig.notifications?.avatar?.myPagesUrl;
    },
    tutorialEnabled() {
      return state.merchantConfig.widgets?.tutorial?.enabled;
    },
    showDMs() {
      return state.merchantConfig.directMessages.enabled;
    },
    hasCustomerAttributes() {
      if (!this.customerAttributeTypes) {
        return false;
      }
      return Object.keys(this.customerAttributeTypes).length > 0;
    },
    use3DAvatar() {
      return state.merchantConfig.avatars.enabled === '3D';
    },
    scrollMargin () {
      const marginTop = this.use3DAvatar ? SCROLL_MARGIN : 0;

      return {
        height: marginTop + 'px',
      };
    },
    scrollHeight() {
      let scroll = this.$refs.scroll;
      if (scroll) {
        let height = scroll.clientHeight;
        return { minHeight: height + 'px'};
      }
      return { minHeight: '100%'};
    },
    isMyProfile() {
      return state.profile && this.merchantCustomerId === state.profile.id;
    },
    profileSkin() {
      if (! this.enabledSkins) {
        return null;
      }
     
      // My profile skins
      if (this.isMyProfile) {
        if (state.profile.overrideSkin) {
          return state.profile.overrideSkin;
        }
        return state.profile.profileSkin;
      }

      // Other user profile skins
      return this.profile?.profileSkin;
    },
    enabledSkins() {
      return state.merchantConfig.widgets?.skins?.enabled;
    },
    showTokenShop() {
      return state.merchantConfig.tokenShop?.enabled;
    },
    showInventory() {
      return state.merchantConfig.inventory?.enabled;
    },
    isDesktop() {
      return this.windowWidth > 1000;
    },
    computedSkinStyle() {
      return {
        backgroundImage: 'url('+(this.profileSkin?.imageUrl || this.profileSkin?.image_url)+')',
        opacity: this.profileSkin?.opacity, 
      };
    },
    darkSkinClass() {
      return { 'gmf-dark': this.profileSkin?.dark };
    },
    menuItems() {
      const showQuests = state.merchantConfig.widgets.dropdownProfilePage.showQuests;

      const items = [];

      items.push({
        value: 'profile',
        name: this.profile?.name || this.t('profile'),
        icon: 'my-pages',
        hideHeader: true,
      });

      if (this.isMyProfile) {
        items.push({
          value: 'notifications',
          name: this.t('notifications'),
          icon: 'tab-notification',
          hideItem: true,
        });
      }

      if (this.showDMs && this.isMyProfile) {
        items.push({
          value: 'direct_messages',
          name: this.t('direct_messages'),
          icon: 'tab-direct-message',
        });
      }

      if (showQuests && this.isMyProfile) {
        items.push({
          value: 'quests',
          name: this.t('quests'),
          icon: 'tab-quest',
          hideHeader: true,
        });
      }

      items.push({
        value: 'achievements',
        name: this.t('achievements'),
        icon: 'tab-achievement',
      });

      if (this.isMyProfile) {
        items.push({
          value: 'ordered_products',
          name: this.t('ordered_products'),
          icon: 'tab-products',
          hideHeader: true,
        });
      }

      items.push({
        value: 'my_content',
        name: this.isMyProfile ? this.t('my_content') : this.t('my_content_public'),
        icon: 'tab-my-content',
      });

      if (this.showInventory) {
        items.push({
          value: 'inventory',
          name: this.isMyProfile ? this.t('inventory') : this.t('inventory_public'),
          icon: 'emoji',
        });
      }

      items.push({ isSpacer: true });

      if (this.isMyProfile) {
        items.push({
          value: 'customer_settings',
          name: this.t('customer_attributes'),
          icon: 'change_avatar',
        });
      }

      if (this.showTokenShop && this.isMyProfile) {
        items.push({
          value: 'token_shop',
          name: this.t('token_shop'),
          icon: 'token-shop',
          isButton: false,
          action: openTokenShop
        });
      }

      const linksUnderMypages = state.merchantConfig.profileCard?.links?.showUnderMyPagesBtn;

      const linkItems = this.links.map(link => ({
        value: link.key,
        name: state.t('profile_links.' + link.key + '.label') || link.key,
        icon: link.icon,
        isButton: linksUnderMypages,
        url: link.url,
      }));

      if (! linksUnderMypages && linkItems.length > 0) {
        items.push(...linkItems);
      }

      if (this.myPagesUrl && this.isMyProfile) {
        items.push({
          value: 'my_pages',
          name: this.t('my_pages'),
          icon: 'my-pages',
          isButton: true,
          action: () => {
            window.open(this.myPagesUrl, "_self");
          },
          children: linksUnderMypages ? linkItems : null,
        });
      }
      items.push({
        value: 'social_feed',
        name: this.t('social_feed'),
        icon: 'tab-forum',
        isButton: true,
        action: () => {
          openSocialModal({ displayHeader: true });
          this.isOpen = false;
        },
      });

      return items;
    },
    smallAvatarStyling() {
      return ! this.use3DAvatar ? { transition: 'unset' } : null; 
    },
    showIcons() {
      return state.merchantConfig.widgets?.customerCardIcons?.enabled;
    }
  },
  watch: {
    selectedItem() {
      if (state.profile && this.enabledSkins) {
        state.profile.overrideSkin = null;
      }
      
      // Scroll to top
      //this.$refs.scroll.scrollTop = Math.min(SCROLL_MARGIN, this.$refs.scroll.scrollTop);
    },
  },
};
</script>
